import { NavLink, useLocation } from "react-router-dom";
import {
  FaUser,
  FaHome,
  FaUsers,
  FaBook,
  FaThList,
  FaCog,
  FaChevronDown,
  FaChevronRight,
  FaEnvelope,
  FaUserShield,
  FaChartLine,
  FaHourglassHalf,
  FaList,
  FaCalendarAlt,
  FaUserFriends,
  FaBookReader,
  FaStar,
  FaLanguage,
  FaBirthdayCake,
  FaStore,
  FaLock,
} from "react-icons/fa";
import { MdOutlineLogout, MdEvent, MdGroups, MdPeople } from "react-icons/md";

import { useState, useEffect } from "react";
import { IoMdClose, IoMdMenu } from "react-icons/io";
import { useAuth } from "../context/auth";
import { toast } from "react-hot-toast";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [openMenus, setOpenMenus] = useState({
    ambassadors: false,
    events: false,
    booksReviews: false,
    settings: false,
  });
  const location = useLocation();

  const [auth, setAuth] = useAuth();

  const handleLogout = () => {
    window.location.href = "/";
    setAuth({
      ...auth,
      user: null,
      token: "",
    });
    localStorage.removeItem("auth");
    localStorage.removeItem("profileImage");
    toast.success("Logout Successfully");
  };

  const toggleMenu = (menu) => {
    setOpenMenus((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };

  // Auto-expand menu if current route matches
  useEffect(() => {
    const path = location.pathname;
    if (path.includes("/admin/ambassador") || path.includes("/admin/ambassadors-list")) {
      setOpenMenus((prev) => ({ ...prev, ambassadors: true }));
    }
    if (path.includes("/admin/club-management") || path.includes("/admin/events") || path.includes("/admin/book-duos") || path.includes("/admin/silent-readings")) {
      setOpenMenus((prev) => ({ ...prev, events: true }));
    }
    if (path.includes("/admin/allreviews")) {
      setOpenMenus((prev) => ({ ...prev, booksReviews: true }));
    }
    if (path.includes("/admin/language") || path.includes("/admin/languages") || path.includes("/admin/age-ranges") || path.includes("/admin/email-templates") || path.includes("/admin/admin-users") || path.includes("/admin/ofelliossuggestive") || path.includes("/admin/suggestivebookadd") || path.includes("/admin/storemanage") || path.includes("/admin/google-api") || path.includes("/admin/change-password")) {
      setOpenMenus((prev) => ({ ...prev, settings: true }));
    }
  }, [location.pathname]);

  const NavItem = ({ to, icon: Icon, children, onClick, isSubmenu = false }) => {
    return (
      <NavLink
        to={to}
        onClick={onClick}
        className={({ isActive }) =>
          `flex items-center gap-3 px-4 py-2.5 rounded-md transition-all duration-200 ${
            isActive
              ? "bg-[#34c3c9] text-white"
              : "text-gray-700 hover:bg-gray-50"
          } ${isSubmenu ? "text-sm" : ""}`
        }
      >
        {Icon && <Icon className={`${isSubmenu ? "text-base" : "text-lg"} flex-shrink-0`} />}
        <span className={`${isSubmenu ? "text-sm" : "text-base"} font-medium`}>{children}</span>
      </NavLink>
    );
  };

  const CollapsibleMenu = ({ title, icon: Icon, children, menuKey }) => {
    const isOpen = openMenus[menuKey];
    const path = location.pathname;
    
    let hasActiveChild = false;
    if (menuKey === "ambassadors") {
      hasActiveChild = path.includes("/admin/ambassador") || path.includes("/admin/ambassadors-list");
    } else if (menuKey === "events") {
      hasActiveChild = path.includes("/admin/club-management") || path.includes("/admin/events") || path.includes("/admin/book-duos") || path.includes("/admin/silent-readings");
    } else if (menuKey === "booksReviews") {
      hasActiveChild = path.includes("/admin/allreviews");
    } else if (menuKey === "settings") {
      hasActiveChild = path.includes("/admin/language") || path.includes("/admin/languages") || path.includes("/admin/age-ranges") || path.includes("/admin/email-templates") || path.includes("/admin/admin-users") || path.includes("/admin/ofelliossuggestive") || path.includes("/admin/suggestivebookadd") || path.includes("/admin/storemanage") || path.includes("/admin/google-api") || path.includes("/admin/change-password");
    }

    return (
      <div>
        <button
          onClick={() => toggleMenu(menuKey)}
          className={`w-full flex items-center justify-between gap-3 px-4 py-2.5 rounded-md transition-all duration-200 ${
            isOpen || hasActiveChild
              ? "bg-[#34c3c9] text-white"
              : "text-gray-700 hover:bg-gray-50"
          }`}
        >
          <div className="flex items-center gap-3">
            {Icon && <Icon className="text-lg flex-shrink-0" />}
            <span className="text-base font-medium">{title}</span>
          </div>
          {isOpen ? (
            <FaChevronDown className="text-xs flex-shrink-0" />
          ) : (
            <FaChevronRight className="text-xs flex-shrink-0" />
          )}
        </button>
        {isOpen && (
          <div className="mt-1.5 space-y-0.5 ml-4">
            {children}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {/* Mobile Navbar */}
      <nav className="md:hidden flex items-center justify-between bg-white px-4 py-3 shadow-md sticky top-0 z-50">
        <h5 className="text-lg font-semibold text-gray-800">Admin Panel</h5>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
        >
          <IoMdMenu size={24} className="text-gray-700" />
        </button>
      </nav>

      {/* Sidebar */}
      <div className="min-h-screen">
        {/* Overlay for mobile */}
        {isOpen && (
          <div
            className="fixed inset-0 bg-black/50 z-40 md:hidden"
            onClick={() => setIsOpen(false)}
          />
        )}

        {/* Sidebar Container - Increased width to w-72 (288px) */}
        <aside
          className={`fixed md:static top-0 left-0 h-full md:h-screen w-72 bg-white border-r border-gray-200 z-50 transform transition-transform duration-300 ease-in-out ${
            isOpen ? "translate-x-0" : "-translate-x-full md:translate-x-0"
          }`}
        >
          <div className="flex flex-col h-full">
            {/* Header */}
            <div className="px-6 py-5 border-b border-gray-200">
              <h2 className="text-lg font-bold text-gray-800">Admin Panel</h2>
            </div>

            {/* Navigation */}
            <nav className="flex-1 overflow-y-auto px-2 py-4 space-y-1">
              {/* Dashboard */}
              <NavItem to="/admindashboard" icon={FaHome} onClick={() => setIsOpen(false)}>
                Dashboard
              </NavItem>

              {/* Users */}
              <NavItem to="/admin/alldata" icon={FaUser} onClick={() => setIsOpen(false)}>
                Users
              </NavItem>

              {/* Ambassadors - Collapsible */}
              <CollapsibleMenu
                title="Ambassadors"
                icon={FaUsers}
                menuKey="ambassadors"
              >
                <NavItem
                  to="/admin/ambassador"
                  icon={FaHourglassHalf}
                  onClick={() => setIsOpen(false)}
                  isSubmenu
                >
                  Applications (users still not approved)
                </NavItem>
                <NavItem
                  to="/admin/ambassadors-list"
                  icon={FaList}
                  onClick={() => setIsOpen(false)}
                  isSubmenu
                >
                  Ambassadors List
                </NavItem>
              </CollapsibleMenu>

              {/* Events - Collapsible */}
              <CollapsibleMenu title="Events" icon={MdEvent} menuKey="events">
                <NavItem
                  to="/admin/events"
                  icon={FaCalendarAlt}
                  onClick={() => setIsOpen(false)}
                  isSubmenu
                >
                  All Events
                </NavItem>
                <NavItem
                  to="/admin/club-management"
                  icon={MdGroups}
                  onClick={() => setIsOpen(false)}
                  isSubmenu
                >
                  Book Clubs
                </NavItem>
                <NavItem
                  to="/admin/book-duos"
                  icon={MdPeople}
                  onClick={() => setIsOpen(false)}
                  isSubmenu
                >
                  Book Duos
                </NavItem>
                <NavItem
                  to="/admin/silent-readings"
                  icon={FaBookReader}
                  onClick={() => setIsOpen(false)}
                  isSubmenu
                >
                  Silent Readings
                </NavItem>
              </CollapsibleMenu>

              {/* Books & Reviews - Collapsible */}
              <CollapsibleMenu
                title="Books & Reviews"
                icon={FaBook}
                menuKey="booksReviews"
              >
                <NavItem
                  to="/admin/allreviews"
                  icon={FaStar}
                  onClick={() => setIsOpen(false)}
                  isSubmenu
                >
                  Reviews
                </NavItem>
              </CollapsibleMenu>

              {/* Newsletter List */}
              <NavItem to="/admin/getnewsletter" icon={FaThList} onClick={() => setIsOpen(false)}>
                Newsletter List
              </NavItem>

              {/* Settings - Collapsible */}
              <CollapsibleMenu title="Settings" icon={FaCog} menuKey="settings">
                <NavItem
                  to="/admin/languages"
                  icon={FaLanguage}
                  onClick={() => setIsOpen(false)}
                  isSubmenu
                >
                  Languages
                </NavItem>
                <NavItem
                  to="/admin/age-ranges"
                  icon={FaBirthdayCake}
                  onClick={() => setIsOpen(false)}
                  isSubmenu
                >
                  Age Ranges
                </NavItem>
                <NavItem
                  to="/admin/email-templates"
                  icon={FaEnvelope}
                  onClick={() => setIsOpen(false)}
                  isSubmenu
                >
                  Email Templates
                </NavItem>
                <NavItem
                  to="/admin/admin-users"
                  icon={FaUserShield}
                  onClick={() => setIsOpen(false)}
                  isSubmenu
                >
                  Admin Users
                </NavItem>
                <NavItem
                  to="/admin/ofelliossuggestive"
                  icon={FaStar}
                  onClick={() => setIsOpen(false)}
                  isSubmenu
                >
                  Suggested Books - Reviews
                </NavItem>
                <NavItem
                  to="/admin/suggestivebookadd"
                  icon={FaUserFriends}
                  onClick={() => setIsOpen(false)}
                  isSubmenu
                >
                  Suggested Books - Book Duo
                </NavItem>
                <NavItem
                  to="/admin/storemanage"
                  icon={FaStore}
                  onClick={() => setIsOpen(false)}
                  isSubmenu
                >
                  Buy On menu
                </NavItem>
                <NavItem
                  to="/admin/google-api"
                  icon={FaChartLine}
                  onClick={() => setIsOpen(false)}
                  isSubmenu
                >
                  Google Analytics API
                </NavItem>
                <NavItem
                  to="/admin/change-password"
                  icon={FaLock}
                  onClick={() => setIsOpen(false)}
                  isSubmenu
                >
                  Change Password
                </NavItem>
              </CollapsibleMenu>
            </nav>

            {/* Logout Button */}
            <div className="px-4 py-4 border-t border-gray-200">
              <button
                onClick={handleLogout}
                className="w-full flex items-center gap-3 px-4 py-2.5 rounded-md bg-gray-50 text-gray-700 hover:bg-gray-100 transition-all duration-200 font-medium"
              >
                <MdOutlineLogout className="text-lg flex-shrink-0" />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </aside>
      </div>
    </>
  );
};

export default Sidebar;
